import { HttpRequestType } from "./HttpRequestType";
import HttpRequestOption from "./HttpRequestOption";
import { SetupHttpRequestUtil } from "../../../SetupHttpRequestUtil";
export var HttpRequestUtil;
(function (HttpRequestUtil) {
    var StatusCode = HttpRequestType.StatusCode;
    var DisplayMessageType = HttpRequestType.DisplayMessageType;
    var ResponseType = HttpRequestType.ResponseType;
    var MethodType = HttpRequestType.MethodType;
    var ResponseResult = HttpRequestType.ResponseResult;
    const abortControllerMap = {};
    /**
     * HttpリクエストのGET
     * @param url
     * @param successCallback
     * @param option
     */
    function getRequest(url, successCallback, option = HttpRequestOption.createForGet()) {
        request(url, MethodType.Get, null, successCallback, option);
    }
    HttpRequestUtil.getRequest = getRequest;
    function postRequest(url, body, successCallback, option = HttpRequestOption.createForPost()) {
        request(url, MethodType.Post, body, successCallback, option);
    }
    HttpRequestUtil.postRequest = postRequest;
    function deleteRequest(url, body, successCallback, option = HttpRequestOption.createForDelete()) {
        request(url, MethodType.Delete, body, successCallback, option);
    }
    HttpRequestUtil.deleteRequest = deleteRequest;
    function putRequest(url, body, successCallback, option = HttpRequestOption.createForDelete()) {
        request(url, MethodType.Put, body, successCallback, option);
    }
    HttpRequestUtil.putRequest = putRequest;
    /**
     * すべてのリクエスト処理
     * @param url
     * @param method
     * @param body
     * @param successCallback
     * @param option
     * @private
     */
    function request(url, method, body, successCallback, option) {
        const httpRequestSetting = SetupHttpRequestUtil.setting;
        const displayMessageType = option.displayMessageType;
        const signalId = option.signalId;
        if (signalId != null) {
            // 同地 signalId で既に実行されているリクエストがあるか
            if (signalId in abortControllerMap) {
                const abortController = abortControllerMap[signalId];
                abortController.abort();
            }
        }
        // options の情報を取得
        const progressMessage = option.progressMessage;
        const responseType = option.responseType;
        const settingMap = {};
        settingMap["method"] = method;
        if (body !== null) {
            if (Object.prototype.toString.call(body) === '[object FormData]') {
                // ファイルなどを含む FormData の場合
                settingMap['body'] = body;
            }
            else {
                // 通常のパラメータの場合
                settingMap["headers"] = {
                    "Content-Type": "application/json; charset=utf-8",
                };
                const json = JSON.stringify(body);
                settingMap["body"] = json;
            }
        }
        if (displayMessageType === DisplayMessageType.All) {
            // すべてのメッセージを表示する場合、進捗メッセージを表示
            httpRequestSetting.executeProgressMessage(progressMessage);
        }
        if (signalId != null) {
            // 中断するための AbortController を作成
            const abortController = new AbortController();
            const fetchSignal = abortController.signal;
            settingMap['signal'] = fetchSignal;
            abortControllerMap[signalId] = abortController;
        }
        fetch(url, settingMap).then(response => {
            // signalId が指定されている場合、abortController を削除
            if (signalId != null) {
                delete abortControllerMap[signalId];
            }
            if (displayMessageType === DisplayMessageType.All) {
                // すべてのメッセージを表示する場合、進捗メッセージをクリア
                if (progressMessage != null) {
                    if (httpRequestSetting.progressMessageAction != null) {
                        // 進捗メッセージをクリア
                        httpRequestSetting.progressMessageAction('');
                    }
                }
            }
            const statusCode = response['status'];
            // bodyが返ってこないステータスコードの場合、先にチェック
            if (statusCode === StatusCode.NotModified) {
                if (displayMessageType === DisplayMessageType.All) {
                    httpRequestSetting.responseNotModifiedActionFunction();
                }
                return;
            }
            else if (statusCode === StatusCode.ServiceUnavailable) {
                // サービスがメンテナンス中
                httpRequestSetting.responseServiceUnavailableActionFunction();
                return;
            }
            else if (statusCode === StatusCode.TooManyRequests) {
                // 大量リクエストがきた場合
                return;
            }
            else if (statusCode === StatusCode.UnAuthorized) {
                // 認証情報がない場合
                httpRequestSetting.responseUnAuthorizedActionFunction();
                return;
            }
            else if (statusCode === StatusCode.GatewayTimeout) {
                return;
            }
            else if (statusCode === StatusCode.BadGateway) {
                return;
            }
            if (progressMessage != null) {
                // 基本の終了時アクションを実行
                httpRequestSetting.executeFinishProgressMessage();
            }
            // レスポンスタイプによって、関数を呼び分ける
            switch (responseType) {
                case ResponseType.Json:
                    processJson(response, successCallback, option);
                    break;
                case ResponseType.Text:
                    break;
            }
        }).catch((error) => {
            if (error.toString() === 'AbortError: The user aborted a request.') {
                // HttpRequest が必要に応じてキャンセルされただけの場合はエラーを表示しない
                return;
            }
            console.error('Http Request Failed', error);
        });
    }
    /**
     * Jsonが返ってくる場合の処理
     * @param response
     * @param successCallback
     * @param option
     * @private
     */
    function processJson(response, successCallback, option) {
        const httpRequestSetting = SetupHttpRequestUtil.setting;
        const finishCallback = option.finishCallback;
        const errorCallback = option.errorCallback;
        const displayMessageType = option.displayMessageType;
        const statusCode = response['status'];
        response.json().then(jsonResponse => {
            const responseResult = new ResponseResult();
            responseResult.statusCode = statusCode;
            responseResult.body = jsonResponse;
            const message = jsonResponse['message'];
            // ステータスコードごとの処理
            if (statusCode === StatusCode.Ok || statusCode === StatusCode.Created) {
                // 成功した場合
                // console.log({option});
                if (displayMessageType === DisplayMessageType.All) {
                    // すべてのメッセージを表示する場合、成功メッセージを表示
                    httpRequestSetting.executeSuccessMessage(message, jsonResponse, option);
                }
                // 成功時の処理を実行する
                successCallback(responseResult);
            }
            else if (statusCode === StatusCode.Forbidden) {
                // 権限がない場合
                httpRequestSetting.responseForbiddenActionFunction(message);
                return;
            }
            else {
                // その他のエラー
                if (displayMessageType !== DisplayMessageType.None) {
                    // サイレント実行ではない場合、エラーメッセージは表示する
                    httpRequestSetting.executeErrorMessage(message, jsonResponse);
                }
                // エラー時の処理を実行する
                errorCallback(responseResult);
            }
            // 終了時の処理を実行する
            finishCallback(responseResult);
        });
    }
})(HttpRequestUtil || (HttpRequestUtil = {}));
